import {
  Badge,
  Box,
  Button,
  InlineStack,
  ProgressBar,
  Icon
} from "@shopify/polaris";
import { ChevronDownIcon,ChevronUpIcon,DuplicateIcon } from "@shopify/polaris-icons";
import React, { useEffect, useState } from "react";
import { reqGetOrderNewTrackingQuery } from "../../../../api";
import utils from "../../../../utils/utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

import ShopifyModal from "../../../../components/ShopifyModal";
const OrderTrackingModal = ({
  trackingData,
  setTrackingData,
  manualOrder,
  toastFun,
  handleStoreTabChange
}) => {
  const router = useHistory();
const handleCopy = async (value) => {
    const link = "https://www.trackingmore.com/track/en/" + value + "?source=dsm";
    try {
        await navigator.clipboard.writeText(link);
        toastFun('Copy successfulluy')
        // 2秒后重置复制状态
    } catch (err) {
        console.error('复制失败:', err);
    }
    };

    const handleCopyText = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            toastFun('Copy successfulluy')
            // 2秒后重置复制状态
        } catch (err) {
            console.error('复制失败:', err);
        }
        };
  const [isVisible, setIsVisible] = useState(true);
  const [isAdderss,setIsAddress] = useState(false);
  const [modaData,setModalData] = useState({});
  const [spinnerLoading,setSpinnerLoading] = useState(true);
  const getTrackingDetail = async (id)=>{
    if (id === '') {
      return
    }
    try {
      let params = {
        dsm_record:id
      }
      setSpinnerLoading(true)
      let res = await reqGetOrderNewTrackingQuery(params);
      if (res.code === '200') {
        setModalData(res.data)
      }
      setSpinnerLoading(false)
    } catch (error) {
      
    }
  }
  const handleClose = ()=>{
    setTrackingData({
      open: false,
      id: "",
    });
    setSpinnerLoading(false)
    setModalData({})
  }
  useEffect(() => {
    if (trackingData.open) {
      getTrackingDetail(trackingData.id)
    }
  }, [trackingData]);
  
  return (
    <div>
      <ShopifyModal
        id="order-tracking-modal"
        heading="Order tracking"
        open={trackingData.open}
        onClose={() => handleClose()}
        primaryAction={(spinnerLoading || modaData?.tracking_number === '') ? undefined : {
          icon:DuplicateIcon,
          content: "Copy Tracking Link",
          onAction: () => {handleCopy(modaData?.tracking_number)},
        }}
      >
       {Object.values(modaData).length > 0 ? 
          <>
          <Box>
            <InlineStack align="space-between">
              <Box className="order_tracking_order_id">
                {modaData?.tracking_number ?<InlineStack blockAlign="center" gap={150}>
                <span>{modaData?.tracking_number}</span>
                <p style={{marginTop:'4px',cursor:'pointer'}} onClick={()=>handleCopyText(modaData?.tracking_number)}>
                    <Icon source={DuplicateIcon} tone="basic" />
                </p>
                </InlineStack>:''}
              </Box>
              <Box>
                {manualOrder ? '' : <Box>
                  <span className="order_tracking_order_id_shopify" style={{marginRight:'5px'}} onClick={()=>{
                    if (handleStoreTabChange) {
                      handleStoreTabChange(0)
                    }
                    handleClose()
                    // utils.routeListen('/admin/order_fulfillment?selectedView=0&order_number=' + trackingData?.data?.order_name?.split(
                    //   '#'
                    // )[1] + '&from=tracking')
                    utils.routeJump1(router, '/admin/order_fulfillment?selectedView=0&order_number=' + trackingData?.data?.order_name?.split(
                      '#'
                    )[1] + '&from=tracking')
                  }}>Shopify Order <strong style={{color:'rgba(0, 91, 211, 1)',cursor:'pointer',fontWeight:'450'}}>{trackingData?.data?.order_name}</strong></span>
                  {trackingData?.data?.split_order>0 ? <Badge>Split Order{trackingData?.data?.split_order}</Badge>:''}
                </Box>}
                <Box>Dropshipman Order {trackingData?.data?.dsm_order_name}</Box>
              </Box>
            </InlineStack>
          </Box>
          <Box className="order_tracking_step">
            <Box className="order_tracking_step_title">{modaData?.tracking_process[modaData?.state-1]?.process}</Box>
            <Box className="order_tracking_step_desc">
            Latest Updated: {modaData?.last_update}
            </Box>
          </Box>
          <Box className="order_tracking_process">
            <InlineStack  gap={200} wrap={true}>
              {modaData?.tracking_process?.slice(0,3).map((item, ind) => (
                <Box key={ind} className="order_tracking_process_item">
                  <Box>
                    {modaData?.state >= ind + 1 ? (
                      <ProgressBar progress={100} size="small" tone="success" />
                    ) : (ind + 1) === (modaData?.state + 1) ? (
                      <ProgressBar progress={40} size="small" tone="success" />
                    ) : (
                      <ProgressBar progress={0} size="small" tone="success" />
                    )}
                  </Box>
                  <Box style={{marginTop:'4px'}}>
                    <InlineStack blockAlign="center" gap={100} wrap={false}>
                      <Box className="order_tracking_process_item_icon_check">
                      {modaData?.state >= ind + 1 ? (
                     <span >
                     <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                     <rect x="0.666992" y="0.75" width="16" height="16" rx="8" fill="#29845A"/>
                     <path fillRule="evenodd" clipRule="evenodd" d="M12.6973 5.96967C12.9902 6.26256 12.9902 6.73744 12.6973 7.03033L8.19732 11.5303C7.90443 11.8232 7.42956 11.8232 7.13666 11.5303L4.88666 9.28033C4.59377 8.98744 4.59377 8.51256 4.88666 8.21967C5.17956 7.92678 5.65443 7.92678 5.94732 8.21967L7.66699 9.93934L11.6367 5.96967C11.9296 5.67678 12.4044 5.67678 12.6973 5.96967Z" fill="white"/>
                     </svg>
                     </span>
                    ) : (ind + 1) === (modaData?.state + 1) ? (
                        <span className="order_tracking_process_item_icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <rect x="1" y="1.75" width="14" height="14" rx="7" stroke="#A8D8FF" strokeWidth="2"/>
                                </svg>
                        </span>
                    ) : (
                        <span className="order_tracking_process_item_icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <rect x="1" y="1.75" width="14" height="14" rx="7" stroke="#ccc" strokeWidth="2"/>
                                </svg>
                        </span>
                    )}
                      </Box>
                      <Box
                        className="order_tracking_process_item_title"
                        title={item.title}
                      >
                        {item.title}
                      </Box>
                    </InlineStack>
                  </Box>
                </Box>
              ))}
              <Box className='order_tracking_process_item_line' style={{borderRight:"1px dashed #ccc",width:'1px',height:'30px'}}></Box>
               {modaData?.tracking_process.slice(3,6).map((item, ind) => (
                <Box key={ind} className="order_tracking_process_item">
                  <Box>
                    {modaData?.state >= ind + 4 ? (
                      <ProgressBar progress={100} size="small" tone="success" />
                    ) : (ind + 4) === (modaData?.state + 1) ? (
                      <ProgressBar progress={40} size="small" tone="success" />
                    ) : (
                      <ProgressBar progress={0} size="small" tone="success" />
                    )}
                  </Box>
                  <Box style={{marginTop:'4px'}}>
                    <InlineStack gap={100} wrap={false}>
                      <Box className="order_tracking_process_item_icon_check">
                      {modaData?.state >= ind + 4 ? (
                     <span >
                     <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                     <rect x="0.666992" y="0.75" width="16" height="16" rx="8" fill="#29845A"/>
                     <path fillRule="evenodd" clipRule="evenodd" d="M12.6973 5.96967C12.9902 6.26256 12.9902 6.73744 12.6973 7.03033L8.19732 11.5303C7.90443 11.8232 7.42956 11.8232 7.13666 11.5303L4.88666 9.28033C4.59377 8.98744 4.59377 8.51256 4.88666 8.21967C5.17956 7.92678 5.65443 7.92678 5.94732 8.21967L7.66699 9.93934L11.6367 5.96967C11.9296 5.67678 12.4044 5.67678 12.6973 5.96967Z" fill="white"/>
                     </svg>
                     </span>
                    ) : (ind + 4) === (modaData?.state + 1) ? (
                        <span className="order_tracking_process_item_icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <rect x="1" y="1.75" width="14" height="14" rx="7" stroke="#A8D8FF" strokeWidth="2"/>
                                </svg>
                        </span>
                    ) : (
                        <span className="order_tracking_process_item_icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <rect x="1" y="1.75" width="14" height="14" rx="7" stroke="#ccc" strokeWidth="2"/>
                                </svg>
                        </span>
                    )}
                      </Box>
                      <Box
                        className="order_tracking_process_item_title"
                        title={item.title}
                      >
                        {item.title}
                      </Box>
                    </InlineStack>
                  </Box>
                </Box>
              ))}
            </InlineStack>
          </Box>
        
          <Box>
            <Box className="order_tracking_step_progress">
            <InlineStack align="space-between" blockAlign="center">
            <Box style={{flex:1,fontSize:'14px'}}>Shipment Progress </Box>
            <span style={{cursor:'pointer'}} onClick={() => setIsVisible(!isVisible)}>
           {!isVisible ? <Icon
                source={ChevronDownIcon}
                tone="base"
                />:
            <Icon
            source={ChevronUpIcon}
            tone="base"
            />}
            </span>
            </InlineStack>
            </Box>
            <div className="timeline-container" style={{maxHeight:isVisible ? '300px' :'0',opacity: isVisible ? 1 : 0,
    transition: 'max-height 0.3s ease, opacity 0.2s ease 0.1s'}}>
              {modaData?.tracking_logs.map((item, index) => (
                <div key={index} className="timeline-item">
                  {/* 时间线圆点 */}
                  <div className="timeline-dot-container">
                    <div className="timeline-dot" />
                    {/* 步骤间的连接线 */}
                    {index < modaData?.tracking_logs.length - 1 && (
                      <div className="timeline-connector" />
                    )}
                  </div>

                  {/* 右侧内容 */}
                  <div className="timeline-content">
                    <h3 className="timeline-title">{item.desc}</h3>
                    <p className="timeline-description">{item.time}</p>
                  </div>
                </div>
              ))}
            </div>
          </Box>
          <Box style={{height:'1px',width:'100%',background:'#ccc'}}></Box>
          <Box>
          <Box className="order_tracking_step_progress">
            <InlineStack align="space-between" blockAlign="center">
            <Box style={{flex:1,fontSize:'14px'}}>Address details</Box>
            <span style={{cursor:'pointer'}} onClick={() => setIsAddress(!isAdderss)}>
           {!isAdderss ? <Icon
                source={ChevronDownIcon}
                tone="base"
                />:
            <Icon
            source={ChevronUpIcon}
            tone="base"
            />}
            </span>
            </InlineStack>
            </Box>
            <Box style={{marginTop:'10px',maxHeight:isAdderss ? '300px' :'0',overflow:isAdderss ? 'visiable' : 'hidden',opacity: isAdderss ? 1 : 0,
    transition: 'max-height 0.3s ease, opacity 0.2s ease 0.1s'}}>
                <InlineStack align="space-between" blockAlign="center" gap={100}>
                    <Box style={{flex:1,marginBottom:'10px'}}>
                        <Box style={{fontWeight:650}}>Name</Box>
                        <Box>{modaData?.address.name ? modaData?.address.name : '/'}</Box>
                    </Box>
                    <Box style={{flex:1,marginBottom:'10px'}}>
                    <Box style={{fontWeight:650}}>Company</Box>
                        <Box>{modaData?.address.company ? modaData?.address.company : '/'}</Box>
                    </Box>
                </InlineStack>
                <InlineStack align="space-between" blockAlign="center" gap={100}>
                    <Box style={{flex:1,marginBottom:'10px'}}>
                    <Box style={{fontWeight:650}}>Address</Box>
                        <Box>{modaData?.address.address1 ? modaData?.address.address1 : '/'}</Box>
                    </Box>
                    <Box style={{flex:1,marginBottom:'10px'}}>
                    <Box style={{fontWeight:650}}>Apartment, suite, etc. (optional)</Box>
                        <Box>{modaData?.address.address2 ? modaData?.address.address2 : '/'}</Box>
                    </Box>
                </InlineStack>
                <InlineStack align="space-between" blockAlign="center" gap={100}>
                    <Box style={{flex:1,marginBottom:'10px'}}>
                    <Box style={{fontWeight:650}}>Country/region</Box>
                        <Box>{modaData?.address.country ? modaData?.address.country : '/'}</Box>
                    </Box>
                    <Box style={{flex:1,marginBottom:'10px'}}>
                    <Box style={{fontWeight:650}}>Province</Box>
                        <Box>{modaData?.address.province ? modaData?.address.province : '/'}</Box>
                    </Box>
                </InlineStack>
                <InlineStack align="space-between" blockAlign="center" gap={100}>
                    <Box style={{flex:1,marginBottom:'10px'}}>
                    <Box style={{fontWeight:650}}>City</Box>
                        <Box>{modaData?.address.city ? modaData?.address.city : '/'}</Box>
                    </Box>
                    <Box style={{flex:1,marginBottom:'10px'}}>
                    <Box style={{fontWeight:650}}>ZIP/Postal code</Box>
                        <Box>{modaData?.address.zip ? modaData?.address.zip : '/'}</Box>
                    </Box>
                </InlineStack>
            </Box>
          </Box>
        </>:''}
        {!spinnerLoading && (
          <div>
            <Button variant="plain" onClick={()=>{
              window.open('https://apps.shopify.com/parcelpanel?source=dropshipman', "_blank");
            }}>Create a tracking page for your customers</Button>
          </div>
        )}
      </ShopifyModal>
    </div>
  );
};

export default OrderTrackingModal;
